// Translation: Interface > Copy button (Russian)
export default Object.freeze({
	idle: '',
	success: ''
})
